import React, {useEffect, useState} from "react";
import Panel from "../unfox-design/Panel";
import Header from "../unfox-design/Header";
import Group from "../unfox-design/Group";
import Title from "../unfox-design/Title";
import Select from "../unfox-design/Select";
import Cell from "@vkontakte/vkui/dist/components/Cell/Cell";
import "@vkontakte/vkui/src/components/Cell/Cell.css"
import Input from "../unfox-design/Input";
import Button from "../unfox-design/Button";
import API from "../../API";
import Snackbar from "../unfox-design/Snackbar";
import {TITLE} from "../../config";
import Placeholder from "../unfox-design/Placeholder";

let Friends = (props) => {
    let [removeList, setRemoveList] = useState(["Неизвестно"]);
    let [nickname, setNickname] = useState('');
    let [snack, setSnack] = useState('');
    let [snackText, setSnackText] = useState('');
    let [userInfo, setUserInfo] = useState('');

    let getFriends = () => {
        API.execute('getFriendsList').then(data => {
            let list = [];
            if(data['response']){
                list=data.response;
            }
            setRemoveList(list);
            props.showLoaderFull(false);
        });
    };

    let showSnack = (e, text) => {
        setSnackText(text);
        setSnack(e);
    }


    let addFriend = () => {
        setNickname('');
        API.execute('addFriend', {nickname: nickname}).then(data => {
            showSnack(true, `😁 ${data.response}`);
            getFriends();
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            showSnack(true, `🤔 ${errorMessage}`);
        });
    }

    let removeFriend = (nickname) => {
        API.execute('removeFriend', {nickname: nickname}).then(data => {
            showSnack(true, `😁 ${data.response}`);
            getFriends();
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            showSnack(true, `🤔 ${errorMessage}`);
        });
    }

    useEffect(() => {
        setUserInfo(JSON.parse(localStorage.userInfo));
        props.showLoaderFull(true);
        getFriends();
    }, []);

    return(
        <Panel>
            <Header status={TITLE}>
                Friends
            </Header>
            {userInfo.status === 'premium' ?
                <div>
                    <Group>
                        <Title>Add friend</Title>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Input placeholder="Nickname" value={nickname} onChange={(e) => setNickname(e.target.value)} />
                            <div style={{marginLeft: '12px'}}>
                                <Button style={{padding: '12px 16px'}} onClick={addFriend}>Add</Button>
                            </div>
                        </div>
                    </Group>
                    <Group>
                        <Title>
                            Your friends
                        </Title>
                        <div className="List">
                            {removeList.length<1 ? 'Friends empty' : ''}
                            {removeList.length > 0 &&
                            <div>
                                {removeList.map((item, index) => (
                                    <Cell key={item} removable onRemove={() => {
                                        removeFriend(item);
                                        setRemoveList([...removeList.slice(0, index), ...removeList.slice(index + 1)])
                                    }} removePlaceholder={"Remove"}>{item}</Cell>
                                ))}
                            </div>
                            }
                        </div>
                    </Group>
                </div> : <Placeholder title={'Not enough rights'} ><div>Only for premiums!</div></Placeholder>}
            <Snackbar start={snack} callback={()=>{setSnack(false)}} vertical="bottom" duration={3000}>
                {snackText}
            </Snackbar>
        </Panel>
    )
}

export default Friends;
